'use client'

import dynamic from 'next/dynamic'

export const UserAuthDialogClient = dynamic(
  () => import('@repo/web-auth-dialog').then(mod => mod.UserAuthDialog),
  {
    ssr: false,
  },
)
